import {useEffect, useState} from "react";
import Loading from "../../component/Loading/Loading";
import { useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faShare} from "@fortawesome/free-solid-svg-icons";
import {getAllComments, getCommentStatusText} from "./functions";
import {getManagerHeader, getReporterHeader} from "../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../assets/Constants";
import {base64DecodeUnicode, toastError, toastSuccess} from "../../assets/functions";
import {Button, Modal} from "react-bootstrap";
import Select from "../../component/Select/Select";

const ProductComments = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [allComments, setAllComments] = useState([]);
    const [responseModal, setResponseModal] = useState({
        show: false,
        comment: {},
    });

    useEffect(() => {
        (async () => {
            document.title = "مدیریت کامنت ها"
            const allComments = await getAllComments();
            console.log(allComments);
            setAllComments(allComments);
            setIsLoading(false);
        })();

    }, []);

    if (isLoading)
        return <Loading/>

    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">مدیریت کامنت ها</h1>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className={"table text-center"}>
                                    <thead>
                                    <tr>
                                        <th>ردیف</th>
                                        <th>آیدی</th>
                                        <th>آیدی خبر</th>
                                        <th>امتیاز</th>
                                        <th>نظر</th>
                                        <th>وضعیت</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        allComments.map((comment, index) => {
                                            return (
                                                <tr key={comment.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{comment.id}</td>
                                                    <td>{comment.productId}</td>
                                                    <td>{comment.rate}</td>
                                                    <td>{comment.text}</td>
                                                    <td>
                                                        {getCommentStatusText(comment.statuses)}
                                                    </td>

                                                    <td>
                                                        <button className={"btn btn-secondary"}
                                                                onClick={() => {
                                                                    setResponseModal({show: true, comment: comment});
                                                                }}
                                                        >
                                                            <FontAwesomeIcon icon={faShare}/>
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {responseModal.show && <ResponseModal comment={responseModal.comment} closeModal={() => {
                setResponseModal({show: false, comment: {}});
            }}/>}
        </div>
    );
}

export default ProductComments;


const ResponseModal = ({comment, closeModal}) => {
    const navigate = useNavigate()
    const [modalIsOpen, setIsOpen] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const responseOptions = [
        {
            label: "تایید کامنت",
            value: "CONFIRMED",
        }, {
            label: "حذف کامنت",
            value: "DISABLED",
        }
    ];
    const [response, setResponse] = useState({
        type: "CONFIRMED",
        text: ""
    })

    const handleSubmit = () => {
        const headers = getManagerHeader();
        setIsLoading(true);
        return axios.post(baseCmsApiUrl + 'comments?role=manager', {commentId: comment.id, ...response}, {headers})
            .then((response) => {
                console.log(response)
                console.log(response.data)
                toastSuccess(base64DecodeUnicode(response.statusText))
                navigate(0)
                return response.data;
            })
            .catch((e) => {
                console.error(e)
                toastError(base64DecodeUnicode(e.response.statusText))
                console.log(e.response.data)
            }).finally(() => {
                setIsLoading(false);
            })
    }

    return (
        <Modal className={"modal-lg"} show={modalIsOpen} onHide={closeModal}>
            <Modal.Header closeButton className={"ltr"}>
                <Modal.Title className={"ms-auto"}>ارسال پاسخ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading && <Loading/>}
                {!isLoading && <div className="row">
                    <div className="col-md-6">
                        <Select label={"وضعیت کامنت"} options={responseOptions} value={response.type}
                                onChange={(value) => {
                                    setResponse({...response, type: value})
                                }}/>
                    </div>
                    {response.type == "CONFIRMED" && <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <label className="card-title mb-2">ارسال پاسخ</label>

                                <textarea className={"form-control"} name="text" id="text" rows="3"
                                          value={response.text} onChange={(e) => {
                                    setResponse({...response, text: e.target.value})
                                }}/>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                    بستن
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    ارسال
                </Button>
            </Modal.Footer>
        </Modal>
    )
}